import subscribeNotifications from './subscribeNotifications'
import { Notification, NotificationEntity } from '../types'
import { isEntityNotification } from '../utils'

type NotificationHandler = (notification: Notification<NotificationEntity>) => void

export default function subscribeEntityNotifications(handle: NotificationHandler) {
  subscribeNotifications((notification) => {
    if (isEntityNotification(notification)) {
      handle(notification as Notification<NotificationEntity>)
    }
  })
}
